import { render, staticRenderFns } from "./PaginaHome.vue?vue&type=template&id=3c01edc4"
import script from "./PaginaHome.vue?vue&type=script&lang=js"
export * from "./PaginaHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports